module.exports = __webpack_public_path__ + "static/media/17_tn.e7196796.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/17_tn.jpg
// module id = 505
// module chunks = 0